import React from 'react';
import { motion } from 'framer-motion';
import { FeatureCard } from './FeatureCard';
import { FEATURES } from '../lib/about-data';
import { cn } from '../../../shared/ui/kit/utils';

interface FeaturesGridProps {
    className?: string;
    onFeatureClick?: (featureId: string) => void;
}

export const FeaturesGrid: React.FC<FeaturesGridProps> = ({ 
    className,
    onFeatureClick 
}) => {
    return (
        <div className={cn('px-4 sm:px-6 pb-8', className)}>
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="mb-6 text-center"
            >
                <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                    Возможности
                </h2>
                <p className="text-sm text-gray-500 dark:text-gray-500">
                    Всё, что нужно для контроля вашей инфраструктуры
                </p>
            </motion.div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
                {FEATURES.map((feature, index) => (
                    <FeatureCard
                        key={feature.id}
                        feature={feature}
                        index={index}
                        onClick={() => onFeatureClick?.(feature.id)}
                    />
                ))}
            </div>
        </div>
    );
};